var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckAllIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.17 7.7.011-.013a.438.438 0 0 0-.612-.623L7.24 12.579l-.348.444-.399-.399-2.618-2.616-.006-.006-.006-.007a.438.438 0 0 0-.63-.01l-.353-.354.354.353a.438.438 0 0 0 .01.63l.007.006.007.006 3.307 3.308a.437.437 0 0 0 .488.09l5.116-6.325Zm0 0-.01.012m.01-.013-.01.013m0 0-4.974 6.22m4.973-6.22-4.973 6.22m0 0a.438.438 0 0 1-.132.092l.132-.091Zm3.546-.833.55-.687.21.212.399.4.348-.444 4.332-5.52a.438.438 0 0 1 .131-.097l-.217-.45.217.45a.438.438 0 0 1 .49.076l.343-.364-.342.364a.437.437 0 0 1 .007.63l-.02.02-.02.023-4.975 6.22a.438.438 0 0 1-.62.001l-.833-.834Z",
    fill: "#374151",
    stroke: "#6B7280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAllIcon);
export default __webpack_public_path__ + "static/media/check-all-icon.47da1ad83b372dd381902041354ff0e9.svg";
export { ForwardRef as ReactComponent };